import { nextTick } from 'vue';

const state = {
    isSidebarCollapsed: false,
    theme: localStorage.getItem('theme') || 'light',
};

const mutations = {
    TOGGLE_SIDEBAR(state) {
        state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    TOGGLE_THEME(state) {
        state.theme = state.theme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', state.theme);
        localStorage.setItem('theme', state.theme);
    }
};

const actions = {
    toggleSidebar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    toggleTheme({ commit }) {
        const reduzMovimento = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        if (!document.startViewTransition || reduzMovimento) {
            commit('TOGGLE_THEME');
            return;
        }
        const root = document.documentElement;
        root.classList.add('theme-switching');
        const transicao = document.startViewTransition(async () => {
            commit('TOGGLE_THEME');
            await nextTick();
        });
        transicao.finished.finally(() => root.classList.remove('theme-switching'));
    },
    initTheme({ state }) {
        document.documentElement.setAttribute('data-theme', state.theme);
    }
};

const getters = {
    isSidebarCollapsed: (state) => state.isSidebarCollapsed,
    theme: (state) => state.theme,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
